<template>
  <div id="modal-template">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="modal-body">
              <div class="bg-loader">
                <p> Cargando...</p>
                <div class="progress">
                  <div class=""></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
/**
 * @component HelpCenterLoader
 * @description Modal de carga a pantalla completa del Centro de Ayuda mientras llega el catálogo.
 * Sus estilos viven en assets/css/help-center/help-center.css.
 * @example <help-center-loader />
 */
export default {
  name: 'HelpCenterLoader'
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/help-center/HelpCenterLoader.vue